//@ts-check

import { mustBeHtmlElementIfPresent } from "common/dom-utils";

/**
 * Get the CSRF token from the meta tag.
 * @returns {string | null} CSRF token from the meta tag
 */
export function getCsrfToken() {
  const el = document.querySelector("meta[name='csrf-token']");
  return mustBeHtmlElementIfPresent(el, "csrf-token meta tag")?.content || null;
}
